// import React,{ useEffect } from 'react';
// import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
// import './App.css';

// import PythonDetail from './components/PythonDetail';
// import PhpDetail from './components/PhpDetail';
// import SQLDetail from './components/SQLDetail';
// import VMware7Detail from './components/VMware7Detail';
// import PythonDataAnalysisDetail from './components/PythonDataAnalysisDetail';
// import RedHatSystemAdministrationIDetails from './components/RedHatSystemAdministrationIDetails';
// import RedHatSystemAdministrationIIDetails from './components/RedHatSystemAdministrationIIDetails';
// import HtmlJavascriptDetail from './components/HtmlJavascriptDetail';
// import OracleDetail from './components/OracleDetail';
// import JavascriptDetail from './components/JavascriptDetail';
// import AngularDetail from './components/AngularDetail';
// import AboutUsDetail from './components/AboutUsDetail'; 
// import Navbar from './components/Navbar';
// import Home from './components/Home';
// import Courses from './components/Courses';
// import Contact from './components/Contact';
// import Footer from './components/Footer';

// import EducationContent from './components/EducationalContent'; 

// const ScrollToSection = () => { 
//     const location = useLocation(); 

//      useEffect(() => {
//     if (location.hash) {
//       const element = document.getElementById(location.hash.substring(1));
//       if (element) {
//         setTimeout(() => {
//           element.scrollIntoView({ behavior: 'smooth' });
//         }, 0); // Adjust the delay as needed
//       }
//     }
//   }, [location]);

//     return null;
// };

// function App() {
//     return (
//         <Router>
//             <ScrollToSection />
//             <div className="App">
//                 <Navbar />
//                 <Routes>
//                     <Route path="/" element={
//                         <>
//                             <Home/>
//                             <EducationContent/>
//                             <Courses/>
                   
//                             <Contact/>
//                        </>
//                     } />
//                   <Route path="/course/:courseName" element={<PythonDetail />} />
//                   <Route path="/course/:courseName" element={<PhpDetail />} />
//                   <Route path="/course/:courseName" element={<SQLDetail />} />
//                   <Route path="/course/:courseName" element={<VMware7Detail />} />
//                   <Route path="/course/:courseName" element={<PythonDataAnalysisDetail />} />
//                   <Route path="/course/:courseName" element={<RedHatSystemAdministrationIDetails />} />
//                   <Route path="/course/:courseName" element={<RedHatSystemAdministrationIIDetails />} />
//                   <Route path="/course/:courseName" element={<HtmlJavascriptDetail/>} />       
//                   <Route path="/course/:courseName" element={<OracleDetail />} />

//                     <Route path="/course/:courseName" element={<JavascriptDetail />} />
//                     <Route path="/course/:courseName" element={<AngularDetail  />} />
//                     <Route path="/aboutus" element={<AboutUsDetail  />} />
              
//                   </Routes>
//                 <Footer />
//             </div>
//         </Router>
//     );
// }

// export default App;
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import './App.css';

import Navbar from './components/Navbar';
import Home from './components/Home';
import Courses from './components/Courses';
import Contact from './components/Contact';
import Footer from './components/Footer';
import EducationContent from './components/EducationalContent'; 
import AboutUsDetail from './components/AboutUsDetail';
import CourseDetail from './components/CourseDetail'; // Import new CourseDetail

const ScrollToSection = () => { 
  const location = useLocation(); 

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 0); 
      }
    }
  }, [location]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToSection />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={
            <>
              <Home />
              <EducationContent />
              <Courses />
              <Contact />
              
            </>
          } />
          
          {/* Only ONE route for all courses */}
          <Route path="/course/:courseName" element={<CourseDetail />} />

          <Route path="/aboutus" element={<AboutUsDetail />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
